import React from 'react';
import { useState,useEffect } from 'react';
import axios from 'axios';
import Table from 'react-bootstrap/Table';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';


function AffichageEquipeClassement(props) {

  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [classement, setClassement] = useState(null);
  const { idEquipe } = useParams();
  const { nomEquipe } = useParams();
  const Navigate = useNavigate()
  const [pasDispo,setPasDispo] = useState(false)
  const apiUrl = process.env.REACT_APP_API_URL;



  useEffect(() => {
      setIsLoading(true);
      const fetchData = async () => {
        try {
          const response = await axios.get(
            `${apiUrl}/classement/affichage/${idEquipe}`,
          );
          setClassement(response.data);
          setError(null);
          setIsLoading(false);



        } catch (error) {
          if (error.response) {
            if (error.response.status === 404) {
                setPasDispo(true);
            } else {
                setError(error.response.data.message);
            }
        } else {
            setError(true);
        }
        setIsLoading(false);

        }
      };

      fetchData(); 
    }, [apiUrl, idEquipe]);
  


    if (isLoading) {
         return (
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
          </div>
          
          );  
        }

        if(error){
          return (
              <>
              <div id="alert-message" className="alert4" >
                  <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
              </div>
            </>  
          )
      }





  return (
  <>
   {pasDispo && (
        <Modal show={pasDispo} onHide={() => Navigate('/arbitre/tableau-de-bord/classement')}>
                <Modal.Header closeButton>
                  <Modal.Title>Aucun classement trouvé pour cette équipe</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <>Aucun classement trouvé pour <strong>{nomEquipe}</strong>.</>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary"  onClick={() => Navigate('/arbitre/tableau-de-bord/classement')} >
                    Quitter
                  </Button>
                </Modal.Footer>
        </Modal>
    )
    
    }
  {props.userData && classement && classement.classement.length > 0 && (
    <>
    <div className="joueur equipe">
        <div className="image7"><img src='/img/bel.png'  alt="logo de l'Union Belge de football" width="100" height="100"/></div>
        <div className="nom"><a href={`/arbitre/tableau-de-bord/equipe/${idEquipe}`}><span style={{textTransform : 'capitalize'}}>{nomEquipe}</span></a></div>
         <div className="nbr">{classement.classement[0].nom}</div>
         <br/>
    </div>
    <hr></hr>
    <div className="wrapper">
    <Table striped bordered hover>
          <thead>
            <tr>
              <th>Rang</th>
              <th>Team</th>
              <th>M</th>
              <th>V</th>
              <th>N</th>
              <th>D</th>
              <th>Buts</th>
              <th>+/-</th>
              <th>Points</th>
            </tr>
          </thead>
          <tbody>
                   {classement && classement.classement.map((item, index) => (
                    <tr key={index} >
                                       <td className="rank">{item.position}</td>
                                       <td className="team">{item.equipe}</td>
                                       <td className="matchs">{item.matchs}</td>
                                       <td className="win">{item.victoires}</td>
                                       <td className="match_nul">{item.nul}</td>
                                       <td className="loose">{item.défaites}</td>
                                       <td className="buts">{item.buts}</td>
                                       <td className="diff">{item.différence}</td>
                                       <td className="points">{item.points}</td>
                    </tr>
                 ))}

              </tbody>
            </Table>
    </div>
             
      </>
      )}
  </>
  );
}

export default AffichageEquipeClassement;
